import React from 'react';
import {CurrencyValue} from '../../../src/models/interfaces';
import {formatCurrency} from '../../../src/util/currency-util';
import {useApis} from '../apis/ApisContext';

interface CurrencyProps {
  value?: null | CurrencyValue;
}

export const Currency: React.FC<CurrencyProps> = React.memo(({value}) => {
  const {t, locale} = useApis();
  return <>{value?.val && value?.unit ? formatCurrency(t, locale, value.val, value.unit) : '-'}</>;
});
